// Mirrors server/src/utils/passwordPolicy.js. The server does the full check
// (common passwords, name/e-mail); this only gives quick feedback in forms.
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_HINT = `Minimaal ${PASSWORD_MIN_LENGTH} tekens, met minstens één letter en één cijfer. Geen veelgebruikt wachtwoord en niet je naam of e-mailadres.`;

export const quickPasswordCheck = (password) => {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Wachtwoord moet minimaal ${PASSWORD_MIN_LENGTH} tekens zijn`;
  }
  if (!/\p{L}/u.test(password) || !/\d/.test(password)) {
    return 'Wachtwoord moet minstens één letter en één cijfer bevatten';
  }
  return null;
};
